/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file debounce.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * debounce.js can not be copied and/or distributed
 * without the express permission of keni
 */

/**
 * Created by keni on 27/04/2017.
 * @link https://davidwalsh.name/javascript-debounce-function
 */

export function deBounce(func, wait, immediate) {
	let timeout = 0,
		context = this, args = arguments,
		later = function () {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		},
		callNow = immediate && !timeout;

	clearTimeout(timeout);
	timeout = setTimeout(later, wait);
	if (callNow) {
		func.apply(context, args);
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/debounce.js